import * as de from './de.json';
import * as en from './en.json';

export default {de, en};